export default __webpack_public_path__ + "static/media/nature.d72be79c.svg";